import { createAction, props } from '@ngrx/store';
import { Negotiation } from 'src/app/components/negotiations/negotiations.model';

export const fetchNegotiations = createAction(
  '[Negotiations] Fetches user negotiation data'
);

export const newNegotiationData = createAction(
  '[Negotiations] Negotiation data is returned',
  props<{ negotiations: Negotiation[] }>()
);
